export default __webpack_public_path__ + "static/media/sample1.136ee57a.jpeg";